import { ReactNode, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchSenders } from 'modules/senders/actions';
import {
  useAssetManagerContext,
  AssetDetails,
} from 'modules/assetManager/contexts/BaseAssetManagerContext';
import { ContactCard, VerifiedContactCardFieldsInput } from '../types';
import { ContactCardContext, ContactCardContextState } from './ContactCardContext';

type ContactCardContextProviderProps = {
  children?: ReactNode;
};

export const ContactCardContextProvider = ({ children }: ContactCardContextProviderProps) => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchSenders());
  }, []);
  const smsSenders = useSelector((state: any) => state?.settings?.senders?.smsSenders || []);

  const {
    assets,
    assetTypeName,
    isModalOpen,
    isEditing,
    changesMade,
    selectedAssetId,
    assetDetails,
    assetErrors,
    onSearch,
    selectAssetInList,
    handleClose,
    createNew,
    save,
    cancel,
    setIsModalOpen,
    setIsEditing,
    setChangesMade,
    updateAssetDetails,
    updateAssetErrors,
    deleteAsset,
  } = useAssetManagerContext();

  const transformToInput = (
    updatedFields: AssetDetails<ContactCard>,
  ): VerifiedContactCardFieldsInput => {
    return {
      displayName: updatedFields?.displayName,
      smsSenderId: updatedFields?.smsSender?.id,
      website: updatedFields?.website,
      imageUrl: updatedFields?.imageUrl,
      subheader: updatedFields?.subheader,
      email: updatedFields?.email,
    };
  };

  const context: ContactCardContextState = {
    smsSenders,
    assets: assets as ContactCard[],
    assetTypeName,
    isModalOpen,
    isEditing,
    changesMade,
    selectedAssetId,
    assetDetails: assetDetails as AssetDetails<ContactCard>,
    assetErrors,
    onSearch,
    selectAssetInList,
    handleClose,
    createNew,
    save: () => save(transformToInput),
    cancel,
    setIsModalOpen,
    setIsEditing,
    setChangesMade,
    updateAssetDetails,
    updateAssetErrors,
    deleteAsset,
  };

  return <ContactCardContext.Provider value={context}>{children}</ContactCardContext.Provider>;
};
